export default "__VITE_ASSET__DKAf4BWz__"